<template>
  <div class="bg-primary seth-set px-6 py-12 flex justify-between">
    <div class="w-full">
      <h2 class="text-white text-2xl font-semibold">{{ title }}</h2>
      <p class="text-white fsize12 w-1/2 mt-2">
        {{ description }}
      </p>
    </div>

    <NotificationUser />
  </div>
</template>
<script>
import NotificationUser from "@/views/adminPanel/pages/dashboard/NotificationUser";
export default {
  props: {
    title: {
      type: String,
      default: "Title",
    },
    description: {
      type: String,
      default: "Description",
    },
  },
  components: {
    NotificationUser,
  },
};
</script>
